export const autoNav = () => {
  const INITIAL_HEIGHT = 0

  function documentOffsetTop(el) {
    return el.offsetTop +
    (el.offsetParent ? documentOffsetTop(el.offsetParent)
      : INITIAL_HEIGHT)
  }

  const scrolly = (time, el) => {
    setTimeout(async () => {
      const offset = 50
      const top = documentOffsetTop(el) - offset
      window.scrollTo({ top, behavior: 'smooth' })
    }, time)
  }

  const autoNavContainer = document.querySelector('.js-auto-nav-text')
  if (autoNavContainer && window.matchMedia('(min-width: 991px)').matches) {
    const idApp = document.getElementById('app')
    idApp.style.overflowX = 'unset'
  }
  let autoNavBlock = document.querySelector('.page-nav--mobile')
  if (window.matchMedia('(min-width: 991px)').matches) {
    autoNavBlock = document.querySelector('.page-nav--desktop')
  }
  if (autoNavContainer) {
    const links = [];
    [...autoNavContainer.querySelectorAll('h2')].forEach((el, i) => {
      // eslint-disable-next-line no-param-reassign
      el.id = `h2-${i}`;
      links.push(`<li><a href="#h2-${i}">${el.textContent}</a></li>`);
    });

    if (links.length > 0) {
      autoNavBlock.querySelector('.page-auto-nav__items').innerHTML = links.join('');
    } else {
      autoNavBlock.remove()
    }

    autoNavBlock.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        if (link.href.includes('#')) {
          const anchor = link.href.split('#')
          const currentBlock = document.getElementById(anchor[1])
          scrolly(20, currentBlock)
        }
      })
    })
  }
  const spyScrolling = () => {
    const sections = document.querySelectorAll('H2');
    const dataPage = document.querySelector('.page-data-privacy');
    if (sections && dataPage) {
      window.onscroll = () => {
        const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
        // eslint-disable-next-line no-restricted-syntax
        for (const s in sections) {
          // eslint-disable-next-line no-prototype-builtins
          if (sections.hasOwnProperty(s) && sections[s].offsetTop <= scrollPos) {
            const active = document.querySelector('.active')
            if (active) {
              document.querySelector('.active').classList.remove('active');
            }
            document.querySelector(`a[href*=${sections[s].id}]`).parentNode.classList.add('active');
          }
        }
      }
    }
  }
  spyScrolling();
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/auto-nav.js